<template>
  <div>
    <menubar leftItemClass="pl-3" rightItemClass="pr-3">
      <template #leftItems>
        <b-btn class="mono" :disabled="!isChannelCreatorLoaded" @click="enableSearch">{{ $t("Search") }}</b-btn>
        <b-dropdown toggle-class="mono" :disabled="!isChannelCreatorLoaded">
          <template #button-content>
            <span>{{ $t("menubar.CatalogGen") }}</span>
          </template>
          <b-dropdown-item link-class="icon-item" v-b-modal.from-text-file-modal>
            <div class="dd-item-container">
              <span class="dd-item-icon"><i class="mdp-FileTxt" /></span>
              <span class="dd-item-text">{{ $t("menubar.FromTextFile") }} </span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item v-if="config.feature.externalDataImportEnabled" link-class="icon-item" @click="isFromExternalSourceModalOpen = true">
            <div class="dd-item-container">
              <span class="dd-item-icon"><i class="mdp-Database" /></span>
              <span class="dd-item-text">{{ $t("GenerateCatalogFromExternalData.FromExternalSource") }}</span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item link-class="icon-item" @click="isGenerateCatalogFromFilterOpen = true">
            <div class="dd-item-container">
              <span class="dd-item-icon"><i class="mdp-Filter" /></span>
              <span class="dd-item-text">{{ $t("menubar.FromArticleFilter") }} </span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <b-btn v-b-modal.auto-mapping-modal class="mono" :disabled="!isChannelCreatorLoaded" data-cy="channel-creator-auto-mapping-btn">{{
          $t("Automapping.Automapping")
        }}</b-btn>
      </template>
      <template #rightItems>
        <b-dropdown toggle-class="btn-icon mono" right no-caret data-cy="context-menu">
          <template #button-content><i class="mdp-Options"></i></template>
          <b-dropdown-item link-class="icon-item" v-b-modal.view-options-modal>
            <div class="dd-item-container">
              <span class="dd-item-icon"><i class="mdp-Preview" /></span>
              <span class="dd-item-text" data-cy="context-menu-view"> {{ $t("menubar.view") }}... </span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item link-class="icon-item" v-b-modal.general-options-modal>
            <div class="dd-item-container">
              <span class="dd-item-icon"> <i class="mdp-Settings" /> </span>
              <span class="dd-item-text" data-cy="context-menu-options"> {{ $t("options") }}... </span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </menubar>
    <view-options-modal></view-options-modal>
    <general-options-modal></general-options-modal>
    <from-text-file-modal></from-text-file-modal>
    <from-external-source-modal v-model="isFromExternalSourceModalOpen"></from-external-source-modal>
    <generate-catalog sourceType="Filter" v-model="isGenerateCatalogFromFilterOpen"></generate-catalog>
    <auto-mapping-dialog></auto-mapping-dialog>
  </div>
</template>
<script>
import menubar from "../../common/components/MenuBar/MenuBar.vue";

import viewOptionsModal from "../components/OptionsMenus/ViewOptionsModal.vue";
import generalOptionsModal from "../components/OptionsMenus/GeneralOptionsModal.vue";
import fromExternalSourceModal from "../components/OptionsMenus/FromExternalSourceModal.vue";
import fromTextFileModal from "../components/OptionsMenus/FromTextFileModal.vue";
import generateCatalog from "./OptionsMenus/GenerateCatalogModal.vue";
import autoMappingDialog from "../components/AutoMapping/AutoMapping.vue";

import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    menubar,
    viewOptionsModal,
    generalOptionsModal,
    fromTextFileModal,
    fromExternalSourceModal,
    generateCatalog,
    autoMappingDialog
  },
  data() {
    return {
      settings: {
        ShowSourceCatalogTreeSearch: true,
        ShowTargetCatalogTreeSearch: true
      },
      isFromExternalSourceModalOpen: false,
      isGenerateCatalogFromFilterOpen: false
    };
  },
  computed: {
    ...mapState(["userSettings"]),
    ...mapState("channelCreator", ["catalogStructure"]),
    ...mapGetters("channelCreator", ["isChannelCreatorLoaded"]),
    ...mapState("metadata", ["config"])
  },
  methods: {
    ...mapActions(["saveUserSettings"]),
    enableSearch() {
      this.settings.ShowSourceCatalogTreeSearch = true;
      this.settings.ShowTargetCatalogTreeSearch = true;
    }
  },
  watch: {
    settings: {
      deep: true,
      handler(nv) {
        this.saveUserSettings(nv);
      }
    },
    userSettings: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!nv) return;

        Object.assign(this.settings, {
          ShowSourceCatalogTreeSearch: nv.ShowSourceCatalogTreeSearch === true || nv.ShowSourceCatalogTreeSearch === "true",
          ShowTargetCatalogTreeSearch: nv.ShowTargetCatalogTreeSearch === true || nv.ShowTargetCatalogTreeSearch === "true"
        });
      }
    }
  }
};
</script>
